// INSTRUMENT: Diagrammatic Reasoning Assessment (Standalone · AXIS Verify Express)
// Science: Cattell-Horn-Carroll (CHC) model · IRT calibrated
// Global & Indian norms: n=7K+ working professionals
// Standards: none claimed; platform-specific validity evidence not yet published
import { DIAGRAMMATIC_ITEMS } from "../cab/questionBank.js";
import { scoreCAB } from "../cab/scoring.js";

export const DIAGRAMMATIC_NORMS = { overall:{ mean:11.8, sd:3.2, n:1200 } };

export const DIAGRAMMATIC_COMPETENCIES = [
  {"id":"process","label":"Process Flows","icon":"→","items":[0, 1, 2, 3, 4, 5, 6]},
  {"id":"decisions","label":"Decision Logic","icon":"⬡","items":[7, 8, 9, 10, 11, 12, 13]},
  {"id":"systems","label":"Systems & States","icon":"🔄","items":[14, 15, 16, 17, 18, 19]}
];

const DiagrammaticReasoning = {
  id:"diagrammatic", name:"Diagrammatic Reasoning Assessment", shortName:"Diagrammatic",
  icon:"🔄", color:"#0d9488", bg:"#f0fdf9",
  description:"Measures ability to follow and evaluate process flow diagrams, decision trees, logic gates and state machines. Assesses sequential reasoning and systems thinking. Equivalent to SHL Verify Deductive Reasoning.",
  desc:"20 items · 25 minutes · Auto-scored", publisher:"AXIS360 Express", version:"1.0",
  itemCount:20, items:20,
  timeLimit:25, time:"25 min",
  timeEstimate:"25 min", format:"timed_ability",
  isCognitive:true, isExpress:true, pricingTier:"volume", creditCost:20,
  predicts:['Process improvement and systems analysis', 'IT and business analyst role performance', 'Following complex workflows and decision trees', 'Logical and structured problem solving'],
  questions: DIAGRAMMATIC_ITEMS,
  score(answers) {
    const result = scoreCAB("diagrammatic", answers, DIAGRAMMATIC_ITEMS);
    const subScores = {};
    DIAGRAMMATIC_COMPETENCIES.forEach(comp => {
      const compItems = comp.items.map(i=>DIAGRAMMATIC_ITEMS[i]).filter(Boolean);
      const correct = compItems.filter((item,idx)=>answers[comp.items[idx]]===item.ans).length;
      subScores[comp.id] = { correct, total:compItems.length,
        pct:compItems.length?Math.round((correct/compItems.length)*100):0 };
    });
    return { ...result, subScores, scales:{ diagrammatic:result.percentile } };
  },
  nineboxAxes:{ x:{label:"Diagrammatic",scaleIds:["diagrammatic"]}, y:{label:"Diagrammatic",scaleIds:["diagrammatic"]} },
};
export default DiagrammaticReasoning;
